module.exports = __webpack_public_path__ + "static/media/country_codes_dialing_A3.77e8aa9a.csv";